// third-party
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

// project import
import reducers from '../store/reducer';
// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const rootReducer = (state, action) => {
    console.log(action);
    if (action.type == "reset_store/handlerResetStore") {
        state=undefined;
    }
    return reducers(state, action)
}

const persistConfig = {
    key:'root',
    storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

const persister = persistStore(store);

// const persister = persistStore(store, {
//     storage: storage
// });
window.persistor=persister
const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;
// export { store, dispatch, useSelector, useDispatch };
export { store, dispatch, persister, useSelector, useDispatch };